import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import MeuPerfilMain from '../components/meu-perfil';

const MeuPerfil = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Meu Perfil'} />
      <MeuPerfilMain/>
    </Wrapper>
  );
};

export default MeuPerfil;